// reducer/index.js
import { combineReducers } from 'redux';
import dashboard from './Dashboard/dashboard.reducer'

const rootReducer = combineReducers({
    dashboard
})

export default rootReducer